import { Component, Input, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-radar-chart-ios',
  templateUrl: './radar-chart-ios.component.html',
  styleUrls: ['./radar-chart-ios.component.scss'],
})
export class RadarChartIosComponent implements OnInit {
  @Input() recievedIosRadarData: any;
  radarChart: any;

  constructor() {}

  ngOnInit(): void {
    console.log('recievedIosRadarData', this.recievedIosRadarData);

    this.createRadarChart();
  }

  createRadarChart() {
    const ctx = document.getElementById('radarChart') as HTMLCanvasElement;
    const radarData = this.recievedIosRadarData;

    const labels = Object.keys(radarData);
    const data = Object.values(radarData).map((value: string) =>
      parseFloat(value)
    );

    this.radarChart = new Chart(ctx, {
      type: 'radar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Dataset',
            data: data,
            backgroundColor: 'rgba(181, 206, 252, 0.5)',
            borderColor: 'rgba(181, 206, 252, 0.5)',
            borderWidth: 1,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false, // Remove the legend
          },
        },
        scales: {
          r: {
            suggestedMin: 0,
            suggestedMax: 100,
            backgroundColor: '#f7f7f7',
            ticks: {
              stepSize: 25,
              backdropColor: '#f7f7f7',
              callback: function (value: number) {
                return value + '%';
              },
            },
          },
        },
      },
    });
  }
}
